import { PopupAction } from "../actions";
import { ActionTypes } from "../const/ActionTypes";

export interface PopupState {
    isOpened: boolean;
    autoMessagesShown: boolean;
    isMessagesShown: boolean;
}

const initialState: PopupState = {
    autoMessagesShown: true,
    isOpened: false,
    isMessagesShown: false,
};

export const popupReducer = (state: PopupState = initialState, action: PopupAction): PopupState => {
    switch (action.type) {
        case ActionTypes.CLOSE_POPUP:
            return { ...state, isOpened: false };
        case ActionTypes.OPEN_POPUP:
            return { ...state, isOpened: true };
        case ActionTypes.SHOW_MESSAGES:
            return { ...state, isMessagesShown: true, autoMessagesShown: false };
        case ActionTypes.HIDE_MESSAGES:
            return { ...state, isMessagesShown: false, autoMessagesShown: false };
        case ActionTypes.RESET_POPUP_STATE:
            return { ...initialState };
        default:
            return state;
    }
};
